<clr-datagrid [clrDgLoading]="loading">
    <clr-dg-column [clrDgField]="'number'">Rechnung</clr-dg-column>
    <clr-dg-column>Jobnummer</clr-dg-column>
    <clr-dg-column [clrDgField]="'order_id'">Bestellnummer</clr-dg-column>
    <clr-dg-column [clrDgField]="'project'">Kunde/Betreff</clr-dg-column>
    <clr-dg-column [clrDgField]="'dateI'">Datum</clr-dg-column>
    <clr-dg-column [clrDgField]="'dateII'">Fälligkeit</clr-dg-column>
    <clr-dg-column>Status</clr-dg-column>
    <clr-dg-column [clrDgField]="'netto'">Betrag (netto)</clr-dg-column>
    <clr-dg-column>Betrag (brutto)</clr-dg-column>
    <clr-dg-column>Bezahlt (brutto)</clr-dg-column>
    <clr-dg-placeholder>We couldn't find any Invoice!</clr-dg-placeholder>
    <clr-dg-row *clrDgItems="let invoice of invoices">
        <clr-dg-cell [routerLink]="['/invoice/details', invoice.praefix, invoice.number]">{{ invoice.praefix }}.{{ invoice.number }}</clr-dg-cell>
        <clr-dg-cell [routerLink]="['/job/details', invoice.project_id, invoice.job_id]">{{ invoice.project_id }}.0006.{{ invoice.job_id }}</clr-dg-cell>
        <clr-dg-cell>{{ invoice.order_id}}</clr-dg-cell>
        <clr-dg-cell><b>{{ invoice.company_name }}</b><br />{{ invoice.name_project }}<br />{{ invoice.description }}</clr-dg-cell>
        <clr-dg-cell>{{ invoice.dateI | date: 'dd.MM.yyyy' }}</clr-dg-cell>
        <clr-dg-cell>{{ invoice.dateII | date: 'dd.MM.yyyy' }}</clr-dg-cell>
        <clr-dg-cell [className]="findButtonClass(invoice.status)" role="alert">
            <div class="alert-items">
                <div class="alert-item static">
                    <div class="alert-icon-wrapper">
                        <cds-icon *ngIf="invoice.status === 'draft'" class="alert-icon" shape="info-circle"></cds-icon>
                        <cds-icon *ngIf="invoice.status === 'open'" class="alert-icon" shape="info-circle"></cds-icon>
                        <cds-icon *ngIf="invoice.status === 'paid'" class="alert-icon" shape="check-circle"></cds-icon>
                        <cds-icon *ngIf="invoice.status === 'overdue'" class="alert-icon" shape="exclamation-circle"></cds-icon>
                        <cds-icon *ngIf="invoice.status === 'partially'" class="alert-icon" shape="exclamation-triangle"></cds-icon>
                        <cds-icon *ngIf="invoice.status === 'cancelled'" class="alert-icon" shape="exclamation-triangle"></cds-icon>
                    </div>
                    <span *ngIf="invoice.status === 'draft'" class="alert-text">Entwurf</span>
                    <span *ngIf="invoice.status === 'open'" class="alert-text">Offen</span>
                    <span *ngIf="invoice.status === 'paid'" class="alert-text">Bezahlt</span>
                    <span *ngIf="invoice.status === 'overdue'" class="alert-text">Überfällig</span>
                    <span *ngIf="invoice.status === 'partially'" class="alert-text">Teilweise bezahlt</span>
                    <span *ngIf="invoice.status === 'cancelled'" class="alert-text">Storniert</span>
                </div>
            </div>
        </clr-dg-cell>
        <clr-dg-cell class="currency">{{ invoice.netto | currency: 'EUR':'code':'1.2-2':'de' }}</clr-dg-cell>
        <clr-dg-cell class="currency"><b>{{ invoice.skonto | currency: 'EUR':'code':'1.2-2':'de' }}</b></clr-dg-cell>
        <clr-dg-cell class="currency">{{ invoice.paid | currency: 'EUR':'code':'1.2-2':'de' }}</clr-dg-cell>
    </clr-dg-row>
    <clr-dg-footer>
        <clr-dg-pagination #pagination [clrDgPageSize]="50">
            <clr-dg-page-size [clrPageSizeOptions]="[10,25,50,100]">Rechnungen pro Seite</clr-dg-page-size>
            {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
            von  {{ invoices.length }} Rechnung(en)
        </clr-dg-pagination>
    </clr-dg-footer>
</clr-datagrid>
